import { render, staticRenderFns } from "./CreateMetierFromList.vue?vue&type=template&id=c227ca72&"
import script from "./CreateMetierFromList.vue?vue&type=script&lang=js&"
export * from "./CreateMetierFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports